// extracted by mini-css-extract-plugin
export default {"amenitiesRow":"summary_amenitiesRow__dzJYH","searchHeader":"summary_searchHeader__EZ0Rh"};